import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'dmmp-card',
  templateUrl: './card.component.html'
})
export class CardComponent implements OnInit {

  @Input() infoCard
  @Output() page = new EventEmitter()

  constructor() { }

  ngOnInit(): void {
  }

}
